import update from '../../../helpers/update';
import {
  getListData,
  getMetadata,
  createRecord,
  updateRecord,
  getRecord
} from '../../../modules/bin/entityHandlers';
import {
  FRANCHISE_API_PATH,
  FRANCHISES_MESSAGE_CLEAR,
  FRANCHISES_METADATA_REQUESTED,
  FRANCHISES_METADATA_SUCCESS,
  FRANCHISES_METADATA_FAILURE,
  FRANCHISES_LIST_DATA_REQUESTED,
  FRANCHISES_LIST_DATA_SUCCESS,
  FRANCHISES_LIST_DATA_FAILURE,
  FRANCHISES_CREATE_REQUESTED,
  FRANCHISES_CREATE_SUCCESS,
  FRANCHISES_CREATE_FAILURE,
  FRANCHISES_UPDATE_REQUESTED,
  FRANCHISES_UPDATE_SUCCESS,
  FRANCHISES_UPDATE_FAILURE,
  FRANCHISES_GET_REQUESTED,
  FRANCHISES_GET_SUCCESS,
  FRANCHISES_GET_FAILURE
} from './franchiseTypes';

export const clearFranchiseErrors = (record: any) => ({
  type: FRANCHISES_MESSAGE_CLEAR,
  payload: { key: record }
});

export const getFranchiseMetadata = (listKey: any) =>
  getMetadata(
    FRANCHISE_API_PATH,
    listKey,
    FRANCHISES_METADATA_REQUESTED,
    FRANCHISES_METADATA_SUCCESS,
    FRANCHISES_METADATA_FAILURE
  );

export const getFranchiseListData = (
  listKey: any,
  id: any,
  request: any,
  invalidate = false,
  cachedData?: any
) =>
  getListData(
    FRANCHISE_API_PATH,
    listKey,
    id,
    FRANCHISES_LIST_DATA_REQUESTED,
    FRANCHISES_LIST_DATA_SUCCESS,
    FRANCHISES_LIST_DATA_FAILURE,
    request,
    invalidate,
    cachedData
  );

export const getFranchiseListDataBySearchTerm = (
  listKey: any,
  id: any,
  request: any,
  searchTerm: string
) => {
  const newRequest = update(request, { text: { $set: searchTerm } });
  return getFranchiseListData(listKey, id, newRequest, true);
};

export const createFranchise = (payload: any) =>
  createRecord(
    FRANCHISE_API_PATH,
    FRANCHISES_CREATE_REQUESTED,
    FRANCHISES_CREATE_SUCCESS,
    FRANCHISES_CREATE_FAILURE,
    payload,
    null,
    'recordCreate'
  );

export const updateFranchise = (id: number, payload: any) =>
  updateRecord(
    FRANCHISE_API_PATH,
    FRANCHISES_UPDATE_REQUESTED,
    FRANCHISES_UPDATE_SUCCESS,
    FRANCHISES_UPDATE_FAILURE,
    id,
    payload,
    null,
    'recordEdit'
  );

export const getFranchise = (id: number) =>
  getRecord(
    FRANCHISE_API_PATH,
    FRANCHISES_GET_REQUESTED,
    FRANCHISES_GET_SUCCESS,
    FRANCHISES_GET_FAILURE,
    id,
    'recordEdit'
  );
